/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Button } from '@chakra-ui/react'
import { useSelector, useDispatch } from 'react-redux'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import BackButton from 'components/Button/BackButton'
import { useTranslation } from 'react-i18next'

import { useParams, useHistory, Link } from 'react-router-dom'
import * as actions from '../../../redux/actions'

export default function OrderAttributeForm() {
  const { t } = useTranslation()
  const [updatedAttr, setUpdatedAttr] = useState()
  const params = useParams()
  const dispatch = useDispatch()
  const subForm = useSelector((state) => state.subForm)

  useEffect(() => {
    dispatch(actions.subFormGet(params?.formId))
    setUpdatedAttr(subForm?.components)
    return () => {}
  }, [params])

  console.log('LOG', updatedAttr, params)

  const saveOrdered = () => {
    let confirm = window.confirm('ยืนยันการจัดเรียง')
    if (confirm) {
      let newAttrOrder = Array.from(updatedAttr)
      _.map(newAttrOrder, (attr, index) => {
        attr.level = index
      })

      dispatch(actions.subFormPut(params?.formId, { components: newAttrOrder }))
      dispatch(actions.subFormGet(params?.formId))
    }
  }

  const genAttrList = (provided, snapshot) => {
    return _.map(subForm?.components, (component, index) => (
      <Draggable
        key={component?._id}
        draggableId={component?._id}
        index={index}
      >
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className="font-sans"
          >
            <div className="m-2 p-4 border-2 border-gray-200">
              <h3 className="font-semibold">{component?.name} </h3>
            </div>
          </div>
        )}
      </Draggable>
    ))
  }

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)
    return result
  }

  const onBeforeCapture = () => {
    /*...*/
  }

  const onBeforeDragStart = () => {
    /*...*/
  }

  const onDragStart = () => {
    /*...*/
  }
  const onDragUpdate = () => {
    /*...*/
  }
  const onDragEnd = (result) => {
    // the only one that is required
    if (!result.destination && !result.source) {
      return <div></div>
    } else {
      const dragableId = result.draggableId
      const sourcePosition = result.source?.index
      const destinationPosition = result.destination?.index
      console.log(
        'Source Position ' +
          sourcePosition +
          'Destination Position' +
          destinationPosition
      )

      let reOrderItems = reorder(
        updatedAttr,
        sourcePosition,
        destinationPosition
      )
      console.log('Reorder Item', reOrderItems)
      setUpdatedAttr(reOrderItems)
    }
  }

  return (
    <div className="relative flex flex-col min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded">
      <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div className="flex flex-wrap items-center">
          <div className="relative w-full max-w-full flex-grow flex-1">
            <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans">
              {t('setting.systemManagement')}
            </h6>
            <h2 className="text-gray-800  font-bold font-sans">ฟอร์มย่อย</h2>
            <h2 className="text-gray-800 text-2xl font-bold font-sans">
              {subForm?.name}
            </h2>
          </div>
        </div>
        <Button>
          <BackButton />
        </Button>
      </div>
      <div className="flex justify-between p-4">
        <div className="flex justify-items-start">
          {' '}
          <Button
            colorScheme="green"
            variant="solid"
            size="sm"
            onClick={() => saveOrdered()}
          >
            {t('utility.saveArrangement')}
          </Button>
        </div>
        <div className="flex justify-items-end"></div>
      </div>
      <div className="p-4 w-full mb-16">
        <DragDropContext
          onBeforeCapture={onBeforeCapture}
          onBeforeDragStart={onBeforeDragStart}
          onDragStart={onDragStart}
          onDragUpdate={onDragUpdate}
          onDragEnd={onDragEnd}
        >
          <Droppable droppableId="orderDropable">
            {(provided, snapshot) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {genAttrList(provided, snapshot)}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  )
}
